import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter, Youtube, Linkedin, Mail, Phone, MapPin, ShoppingBag, Building2, HeadphonesIcon, Cookie } from "lucide-react";
import { openCookieSettings } from "@/components/CookieConsentBanner";
const Footer = () => {
  const shopLinks = [{
    name: "All Products",
    href: "/shop"
  }, {
    name: "Artisan Gifts",
    href: "/gifts"
  }, {
    name: "Terracotta",
    href: "/category/terracotta"
  }, {
    name: "Madhubani Art",
    href: "/category/madhubani"
  }, {
    name: "Wooden Crafts",
    href: "/category/wooden"
  }, {
    name: "Jewelry",
    href: "/category/jewelry"
  }, {
    name: "Compare",
    href: "/compare"
  }];
  const companyLinks = [{
    name: "Our Story",
    href: "/story"
  }, {
    name: "Craft Traditions",
    href: "/crafts"
  }, {
    name: "Heritage Map",
    href: "/regions"
  }, {
    name: "Meet Artisans",
    href: "/artisans"
  }, {
    name: "Wholesale",
    href: "/wholesale"
  }, {
    name: "Rewards",
    href: "/loyalty"
  }, {
    name: "Gift Cards",
    href: "/gift-cards"
  }, {
    name: "Donate",
    href: "/donate"
  }];
  const supportLinks = [{
    name: "Contact Us",
    href: "/contact"
  }, {
    name: "Support Tickets",
    href: "/support"
  }, {
    name: "FAQs",
    href: "/faq"
  }, {
    name: "Shipping Info",
    href: "/shipping"
  }, {
    name: "Returns & Refunds",
    href: "/returns"
  }, {
    name: "Track Order",
    href: "/track"
  }, {
    name: "Bug Bounty",
    href: "/bug-bounty"
  }];
  return <footer className="bg-earth text-cream relative overflow-hidden">
      {/* Decorative SVG Patterns ... (omitted for brevity, keeping existing) */}
      
      {/* Main Footer */}
      <div className="container py-12 md:py-16 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 md:gap-8">
          {/* Brand */}
          <div className="lg:col-span-2 flex flex-col items-center sm:items-start text-center sm:text-left">
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <div className="w-10 h-10 rounded-full bg-cream flex items-center justify-center transition-transform group-hover:scale-110">
                <span className="text-earth font-display text-xl font-bold">G</span>
              </div>
              <span className="font-display text-xl font-semibold text-cream">
                Gaon<span className="text-golden">ova</span>
              </span>
            </Link>
            <p className="text-cream/70 mb-6 max-w-sm text-sm leading-relaxed">
              Bringing authentic village craftsmanship to modern homes. Every purchase supports rural artisan communities.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://www.facebook.com/people/Gaonova/61572357401434/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-cream/10 rounded-full flex items-center justify-center hover:bg-cream/20 transition-all hover:-translate-y-1" aria-label="Follow us on Facebook">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://www.instagram.com/gaonova.official/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-cream/10 rounded-full flex items-center justify-center hover:bg-cream/20 transition-all hover:-translate-y-1" aria-label="Follow us on Instagram">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://twitter.com/gaonova" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-cream/10 rounded-full flex items-center justify-center hover:bg-cream/20 transition-all hover:-translate-y-1" aria-label="Follow us on Twitter">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="https://linkedin.com/company/gaonova" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-cream/10 rounded-full flex items-center justify-center hover:bg-cream/20 transition-all hover:-translate-y-1" aria-label="Follow us on LinkedIn">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="https://youtube.com/@gaonova" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-cream/10 rounded-full flex items-center justify-center hover:bg-cream/20 transition-all hover:-translate-y-1" aria-label="Subscribe to our YouTube channel">
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Shop Links */}
          <div className="text-center sm:text-left">
            <h3 className="font-display text-base font-semibold mb-5 text-golden flex items-center justify-center sm:justify-start gap-2">
              <ShoppingBag className="h-4 w-4" />
              Shop
            </h3>
            <ul className="space-y-3 text-sm">
              {shopLinks.map(link => <li key={link.name}>
                  <Link to={link.href} className="text-cream/70 hover:text-cream transition-colors">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Company Links */}
          <div className="text-center sm:text-left">
            <h3 className="font-display text-base font-semibold mb-5 text-golden flex items-center justify-center sm:justify-start gap-2">
              <Building2 className="h-4 w-4" />
              Company
            </h3>
            <ul className="space-y-3 text-sm">
              {companyLinks.map(link => <li key={link.name}>
                  <Link to={link.href} className="text-cream/70 hover:text-cream transition-colors">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Support & Contact */}
          <div className="text-center sm:text-left">
            <h3 className="font-display text-base font-semibold mb-5 text-golden flex items-center justify-center sm:justify-start gap-2">
              <HeadphonesIcon className="h-4 w-4" />
              Support
            </h3>
            <ul className="space-y-3 text-sm mb-6">
              {supportLinks.map(link => <li key={link.name}>
                  <Link to={link.href} className="text-cream/70 hover:text-cream transition-colors">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
            
            <div className="flex flex-col items-center sm:items-start gap-3 text-xs">
              <a href="mailto:hello@gaonova.com" className="flex items-center gap-2 text-cream/70 hover:text-cream transition-colors">
                <Mail className="h-4 w-4 text-golden/60" />
                hello@gaonova.com
              </a>
              <a href="tel:+911234567890" className="flex items-center gap-2 text-cream/70 hover:text-cream transition-colors">
                <Phone className="h-4 w-4 text-golden/60" />
                +91 12345 67890
              </a>
              <p className="flex items-start gap-2 text-cream/70 max-w-[200px] sm:max-w-none">
                <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-golden/60" />
                Rural Artisan Hub, Kolkata, India
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-cream/10 bg-black/5">
        <div className="container py-8 flex flex-col lg:flex-row items-center justify-between gap-6 text-sm text-cream/60">
          <p className="text-xs sm:text-sm font-medium">© 2026 Gaonova. All rights reserved.</p>
          <div className="flex flex-wrap items-center justify-center lg:justify-end gap-x-6 gap-y-3 text-[11px] sm:text-xs tracking-wide">
            <Link to="/privacy" className="hover:text-cream transition-colors">Privacy Policy</Link>
            <Link to="/gdpr" className="hover:text-cream transition-colors">GDPR</Link>
            <Link to="/ccpa" className="hover:text-cream transition-colors">Privacy Choices</Link>
            <Link to="/cookies" className="hover:text-cream transition-colors">Cookies</Link>
            <Link to="/terms" className="hover:text-cream transition-colors">Terms of Service</Link>
            <Link to="/taxes" className="hover:text-cream transition-colors">Taxes</Link>
            <Link to="/sitemap" className="hover:text-cream transition-colors">Sitemap</Link>
            <button
              onClick={openCookieSettings}
              className="inline-flex items-center gap-1.5 hover:text-cream transition-colors group"
            >
              <Cookie className="h-3.5 w-3.5 group-hover:rotate-12 transition-transform" />
              Cookie preferences
            </button>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;
